import React from "react";
import { useDispatch } from "react-redux";
import { GenderEnum } from "../../../../utils/Enum";

const GenderButton = ({
  gender,
  updateGender,
  componentType,
  width = "100%",
  handleCustomerDataFieldChange,
}) => {
  const dispatch = useDispatch();

  const handleGender = (value) => {
    let currentValue = gender === value ? null : value;

    if (componentType === "bookingDetails") {
      handleCustomerDataFieldChange("gender", currentValue);
    } else {
      updateGender && dispatch(updateGender(currentValue));
    }
  };

  return (
    <div
      className={`flex flex-nowrap justify-between w-[${width}] items-center 
      border-[1px] border-[#EDF1F7] rounded-[12px]`}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {GenderEnum?.map((genderOption, idx) => {
        return (
          <button
            value={genderOption}
            key={genderOption}
            className={`${
              gender === genderOption
                ? "bg-[#007FFF] text-[#FFF]"
                : "text-[#8F9BB3]"
            } ${
              idx === 0
                ? "rounded-l-[12px] border-r-[1px] border-r-[#F0F0F0]"
                : idx === 2
                ? "rounded-r-[12px] border-l-[1px] border-l-[#F0F0F0]"
                : ""
            } text-[12px] flex justify-center items-center flex-1
            cursor-pointer p-2 px-3 font-[400] border-0 leading-[20px] 
             rounded-[0] capitalize `}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleGender(genderOption);
            }}
          >
            {genderOption}
          </button>
        );
      })}
    </div>
  );
};

export default GenderButton;
